import { Col, Slider } from '@repo/ui/components'
import type { AdvancedTradeBoxBalanceSliderProps } from './advanced-trade-box.types'
import { AdvancedTradeBoxBalanceDisplay } from './advanced-trade-box.balance-display'
import { useIsDesktop } from '@repo/ui/hooks'

export const AdvancedTradeBoxBalanceSlider = (
  props: AdvancedTradeBoxBalanceSliderProps,
) => {
  const {
    title,
    value,
    max,
    onChange,
    currencyLabel,
    onMaxClick,
    color = 'neutral',
  } = props

  const isDesktop = useIsDesktop()

  return (
    <Col className='gap-xs mt-md'>
      {!isDesktop && (
        <AdvancedTradeBoxBalanceDisplay
          title={title}
          max={max}
          currencyLabel={currencyLabel}
          onMaxClick={onMaxClick}
          color={color}
        />
      )}

      <Slider
        min={0}
        max={typeof max === 'number' ? max : 0}
        value={[typeof value === 'number' ? value : 0]}
        onValueChange={([val]) => onChange(val as number)}
      />
    </Col>
  )
}
